import styled from "@emotion/styled";


// Grid container and card styling remains the same
export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 2rem;
  margin-bottom: 4rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 5px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  background-color: #fff;

  img {
    width: 100%;
    height: auto;
    border-radius: 10px 10px 0 0;
    object-fit: cover;
  }

  h4 {
    font-size: 1.2rem;
    font-weight: 500;
    margin-top: 1rem;
    text-align: center;
    color: rgba(0, 0, 0, 0.85);
  }

  p {
    font-size: 1rem;
    margin-top: 0.5rem;
    text-align: center;
    color: rgba(0, 0, 0, 0.65);
  }
`;

export const BtnGroup = styled.div`
  height: 70px;
  display: flex;
  align-items: center;
`;
export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: white;
  padding: 2rem;
  width: 90%;
  // max-width: 640px;
  max-width: 854px;
  max-height: 90%;
  // min-height: 500px;
  min-height: 600px;

  overflow-y: auto;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  position: relative;
  // display: flex; // makes gap  
  flex-direction: column; // Layout in column to have top and bottom
  gap: 2rem;  // Space between top and bottom
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 2rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
`;

// Top section (this will contain left and right)
export const TopContent = styled.div`
  display: flex;
  gap: 2rem;  // Space between left and right
  flex: 1;   // Makes the top section take up available space
`;

// Left and Right content inside the top section
export const LeftContent = styled.div`
  flex: 2; // Left side takes up half the space
  img {
    width: 100%;
    height: auto;
    border-radius: 10px;
  }
`;

export const RightContent = styled.div`
  flex: 1; // Right side takes up half the space
`;

// Bottom section
export const BottomContent = styled.div`
  // remove margins to top
  margin-bottom: 0rem;

  flex: 1; // Adjust the flex based on how much space you want the bottom to take
`;


export const CloseButton = styled.button`
  position: absolute;
  top: 10x;
  right: 10px;
  padding: 0.5rem;
  background: none;
  color: black;
  font-size: 1.0rem;
  border: none;
  cursor: pointer;
`;